import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
import { CustomTemplatesTab } from '../components/templates/CustomTemplatesTab';
import { SystemTemplatesTab } from '../components/templates/SystemTemplatesTab';

type TabType = 'custom' | 'system';

export function Templates() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // Get active tab from URL params, default to 'custom'
  const tabFromUrl = searchParams.get('tab') as TabType | null;
  const validTabs: TabType[] = ['custom', 'system'];
  const activeTab = tabFromUrl && validTabs.includes(tabFromUrl) ? tabFromUrl : 'custom';

  const handleTabChange = (tab: TabType) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('tab', tab);
    setSearchParams(newParams, { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#F5F5F5] pb-20">
      {/* Header */}
      <div className="bg-white shadow-sm sticky top-0 z-20">
        <div className="p-4">
          <div className="flex items-center gap-3 mb-4">
            <button
              onClick={() => navigate(-1)}
              className="text-gray-600 hover:text-gray-800"
            >
              <ArrowLeftIcon className="w-6 h-6" />
            </button>
            <h1 className="text-xl font-semibold text-[#212121]">Templates</h1>
          </div>

          {/* Tabs */}
          <div className="flex gap-1 bg-gray-100 p-1 rounded-lg">
            <button
              onClick={() => handleTabChange('custom')}
              className={`flex-1 py-2.5 px-4 rounded-lg font-medium text-sm transition-all ${
                activeTab === 'custom'
                  ? 'bg-white text-[#212121] shadow-sm'
                  : 'text-gray-600 hover:text-[#212121]'
              }`}
            >
              Custom
            </button>
            <button
              onClick={() => handleTabChange('system')}
              className={`flex-1 py-2.5 px-4 rounded-lg font-medium text-sm transition-all ${
                activeTab === 'system'
                  ? 'bg-white text-[#212121] shadow-sm'
                  : 'text-gray-600 hover:text-[#212121]'
              }`}
            >
              System
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      {activeTab === 'custom' ? <CustomTemplatesTab /> : <SystemTemplatesTab />}

      <BottomNav />
    </div>
  );
}
